import React from 'react';
import { Chip } from '@mui/material';
import { USER_IMPORT_STATUSES } from '../api/userImportsApi';

const STATUS_CHIPS = {
	[USER_IMPORT_STATUSES.queued]: { label: 'Queued', color: 'default' },
	[USER_IMPORT_STATUSES.running]: { label: 'Running', color: 'info' },
	[USER_IMPORT_STATUSES.finished]: { label: 'Finished', color: 'success' },
	[USER_IMPORT_STATUSES.failed]: { label: 'Failed', color: 'error' },
};

/** A user import's status as a coloured chip: queued, running, finished or failed. */
export const UserImportStatusChip = ({ status }) => (
	<Chip size='small' {...STATUS_CHIPS[status]} />
);
